import { render, staticRenderFns } from "./BatchesGrid.vue?vue&type=template&id=1dcf98c9&scoped=true"
import script from "./BatchesGrid.vue?vue&type=script&lang=js"
export * from "./BatchesGrid.vue?vue&type=script&lang=js"
import style0 from "./BatchesGrid.vue?vue&type=style&index=0&id=1dcf98c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf98c9",
  null
  
)

export default component.exports